var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartVe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.04115C19 3.15954 15.8604 0 12 0C8.13961 0 5 3.15807 5 7.04115C5 10.6369 7.69424 13.6107 11.1576 14.0306V18.2453H8.25681C7.79239 18.2453 7.41587 18.6241 7.41587 19.0912C7.41587 19.5584 7.79239 19.9371 8.25681 19.9371H11.1576V23.1541C11.1576 23.6213 11.5341 24 11.9986 24C12.463 24 12.8395 23.6213 12.8395 23.1541V19.9371H15.7403C16.2048 19.9371 16.5813 19.5584 16.5813 19.0912C16.5813 18.6241 16.2048 18.2453 15.7403 18.2453H12.8395V14.0306C16.3044 13.6106 18.9972 10.6368 18.9972 7.04115H19ZM6.68324 7.04115C6.68324 4.09235 9.06836 1.69314 12 1.69314C14.9316 1.69314 17.3168 4.09227 17.3168 7.04115C17.3168 9.98995 14.9316 12.3892 12 12.3892C9.06836 12.3892 6.68324 9.99003 6.68324 7.04115Z",
    fill: "#EC55C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartVe);
export default __webpack_public_path__ + "static/media/chart_ve.cdda6f776a412c652d40e0c4aa5a9430.svg";
export { ForwardRef as ReactComponent };